export const cms = () =>
  import(/* webpackChunkName: "cms" */ '@/pages/cms/index.vue')

// 冻品专区
export const categoryArea = () =>
  import(
    /* webpackChunkName: "category-area" */ '@/pages/category_area/index.vue'
  )
// 摇钱树
export const moneyTree = () =>
  import(/* webpackChunkName: "money-tree" */ '@/pages/moneyTree/index.vue')

// 秒杀新
export const seckillNew = () =>
  import(/* webpackChunkName: "seckillNew" */ '@/pages/seckillNew/index.vue')

// 商城APP下载页
export const appDownload = () =>
  import(/* webpackChunkName: "app-download" */ '@/pages/appDownload/index.vue')

// 相似商品
export const similarGoods = () =>
  import(
    /* webpackChunkName: "similar-goods" */ '@/pages/similarGoods/index.vue'
  )

// 领劵中心
export const couponCenter = () =>
  import(
    /* webpackChunkName: "coupon-center" */ '@/pages/couponCenter/index.vue'
  )

// 账单 - 首页
export const billIndex = () =>
  import(/* webpackChunkName: 'billIndex' */ '@/pages/bill/index.vue')
// 账单 - 导出
export const billExport = () =>
  import(/* webpackChunkName: 'billExport' */ '@/pages/bill/export.vue')
export const billExportList = () =>
  import(/* webpackChunkName: 'billExportList' */ '@/pages/bill/exportList.vue')
// 我的取货码
export const receiveNumber = () =>
  import(
    /* webpackChunkName: 'receiveNumber' */ '@/pages/receiveNumber/index.vue'
  )
// 活动聚合页面
export const activityGoods = () =>
  import(
    /* webpackChunkName: 'activityGoods' */ '@/pages/activityGoods/index.vue'
  )

// export const deliverOrderList = () =>
//   import(
//     /* webpackChunkName: 'deliverOrderList' */ '@/pages/deliverOrder/index.vue'
//   )
export const deliverOrderDetail = () =>
  import(
    /* webpackChunkName: 'deliverOrderDetail' */ '@/pages/deliverOrder/detail.vue'
  )
// pop首页
export const popIndex = () =>
  import(/* webpackChunkName: 'popIndex' */ '@/pages/pop/index.vue')
// 营业执照
export const popQualification = () =>
  import(
    /* webpackChunkName: 'popQualification' */ '@/pages/pop/shopQualification.vue'
  )
// 商家资质
export const popLicense = () =>
  import(/* webpackChunkName: 'popLicense' */ '@/pages/pop/license.vue')
// 商家资质
export const popPersonShopInfo = () =>
  import(
    /* webpackChunkName: 'popPersonShopInfo' */ '@/pages/pop/personShopInfo.vue'
  )

export const personList = () =>
  import(/* webpackChunkName: 'receiveNumber' */ '@/pages/personList/index.vue')

export const personListInfo = () =>
  import(
    /* webpackChunkName: 'receiveNumber' */ '@/pages/personList/info/index.vue'
  )

// 运费相关
export const shippingFeeList = () =>
  import(
    /* webpackChunkName: 'receiveNumber' */ '@/pages/shippingFee/Index.vue'
  )

export const shippingFeeDetail = () =>
  import(
    /* webpackChunkName: 'shippingFeeDetail' */ '@/pages/shippingFee/Detail.vue'
  )

export const shippingFeeRules = () =>
  import(
    /* webpackChunkName: 'receiveNumber' */ '@/pages/shippingFee/Rules.vue'
  )
export const hotSaleList = () =>
  import(/* webpackChunkName: 'hotSaleList' */ '@/pages/hotSaleList/index.vue')
export const key = () =>
  import(/* webpackChunkName: 'key' */ '@/pages/user-center/Key.vue')
export const redPackageRain = () =>
  import(
    /* webpackChunkName: 'redPackageRain' */ '@/pages/redPackageRain/index.vue'
  )
export const quarantineList = () =>
  import(/* webpackChunkName: 'quarantineList' */ '@/pages/quarantine/list.vue')
export const quarantine = () =>
  import(/* webpackChunkName: 'quarantine' */ '@/pages/quarantine/index.vue')
export const newGoodReqList = () =>
  import(/* webpackChunkName: 'newGoodReqList' */ '@/pages/newGoodReq/list.vue')
export const newGoodReqAdd = () =>
  import(/* webpackChunkName: 'newGoodReqAdd' */ '@/pages/newGoodReq/add.vue')
export const newGoodReqDetail = () =>
  import(
    /* webpackChunkName: 'newGoodReqDetail' */ '@/pages/newGoodReq/detail.vue'
  )
export const memberIndex = () =>
  import(/* webpackChunkName: 'memberIndex' */ '@/pages/member/index.vue')
export const memberBuyList = () =>
  import(/* webpackChunkName: 'memberBuyList' */ '@/pages/member/buyList.vue')
export const memberBuyDetail = () =>
  import(
    /* webpackChunkName: 'memberBuyDetail' */ '@/pages/member/buyDetail.vue'
  )
export const cancelOrder = () =>
  import(/* webpackChunkName: 'cancelOrder' */ '@/pages/cancelOrder/index.vue')
export const deliverOrderList = () =>
  import(
    /* webpackChunkName: 'deliverOrderList' */ '@/pages/deliverOrder/list.vue'
  )
export const serviceFee = () =>
  import(/* webpackChunkName: 'serviceFee' */ '@/pages/serviceFee/index.vue')
export const inspectReport = () =>
  import(
    /* webpackChunkName: 'inspectReport' */ '@/pages/inspectReport/index.vue'
  )
export const memberIntegral = () =>
  import(
    /* webpackChunkName: 'memberIntegral' */ '@/pages/memberIntegral/index.vue'
  )
export const memberIntegralDetail = () =>
  import(
    /* webpackChunkName: 'memberIntegralDetail' */ '@/pages/memberIntegral/detail.vue'
  )
export const memberIntegralHistory = () =>
  import(
    /* webpackChunkName: 'memberIntegralHistory' */ '@/pages/memberIntegral/history.vue'
  )
export const memberCouponpack = () =>
  import(
    /* webpackChunkName: 'memberIntegralHistory' */ '@/pages/memberCouponpack/index.vue'
  )
export const memberCouponpackHistory = () =>
  import(
    /* webpackChunkName: 'memberIntegralHistory' */ '@/pages/memberCouponpack/history.vue'
  )
export const memberCouponpackDetail = () =>
  import(
    /* webpackChunkName: 'memberIntegralHistory' */ '@/pages/memberCouponpack/detail.vue'
  )
export const memberCouponpackSuccess = () =>
  import(
    /* webpackChunkName: 'memberIntegralHistory' */ '@/pages/memberCouponpack/success.vue'
  )
export const cartActivityRule = () =>
  import(
    /* webpackChunkName: 'cartActivityRule' */ '@/pages/cartActivityRule/index.vue'
  )
export const userprotocol = () =>
  import(
    /* webpackChunkName: 'userprotocol' */ '@/pages/userprotocol/index.vue'
  )
export const marketResearch = () =>
  import(
    /* webpackChunkName: 'userprotocol' */ '@/pages/marketResearch/index.vue'
  )
export const taskDetail = () =>
  import(
    /* webpackChunkName: 'userprotocol' */ '@/pages/marketResearch/taskDetail.vue'
  )
export const record = () =>
  import(
    /* webpackChunkName: 'userprotocol' */ '@/pages/marketResearch/record.vue'
  )
export const userChangePrice = () =>
  import(
    /* webpackChunkName: 'userChangePrice' */ '@/pages/userChangePrice/index.vue'
  )
export const rechargeCoupon = () =>
  import(
    /* webpackChunkName: 'rechargeCoupon' */ '@/pages/rechargeCoupon/index.vue'
  )
export const goodsRank = () =>
  import(/* webpackChunkName: 'goodsRank' */ '@/pages/goodsRank/index.vue')
export const demandWordRank = () =>
  import(
    /* webpackChunkName: 'demandWordRank' */ '@/pages/demandWordRank/index.vue'
  )
export const activityArea = () =>
  import(
    /* webpackChunkName: 'activityArea' */ '@/pages/activityArea/index.vue'
  )
export const goodConfig = () =>
  import(/* webpackChunkName: 'goodConfig' */ '@/pages/goodConfig/index.vue')
export const stallList = () =>
  import(/* webpackChunkName: 'stallList' */ '@/pages/stall/index.vue')
export const stallEdit = () =>
  import(/* webpackChunkName: 'stallEdit' */ '@/pages/stall/edit.vue')
export const homeGoods = () =>
  import(/* webpackChunkName: 'homeGoods' */ '@/pages/homeGoods/index.vue')
export const keyBox = () =>
  import(/* webpackChunkName: 'keyBox' */ '@/pages/keyBox/index.vue')
export const keyBoxDetail = () =>
  import(/* webpackChunkName: 'keyBoxDetail' */ '@/pages/keyBox/detail.vue')
export const deliveryOrderConfig = () =>
  import(
    /* webpackChunkName: 'deliveryOrderConfig' */ '@/pages/deliverOrder/config.vue'
  )
